var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.656 22.2679C23.656 23.4911 22.6619 24.5227 21.4387 24.5227H3.696C2.47279 24.5227 1.47868 23.4911 1.47868 22.2679V4.52521C1.47868 3.302 2.47279 2.34399 3.696 2.34399H14.0453V0.866699H3.696C1.65778 0.866699 0 2.48838 0 4.5266V22.2679C0 24.3062 1.65778 26 3.696 26H21.4373C23.4755 26 25.1333 24.3048 25.1333 22.2679V11.9547H23.6547V22.2679H23.656Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0597 4.03913L23.5299 4.56982L21.4079 2.44422L21.9377 1.91353C22.5041 1.34614 23.4932 1.34614 24.0597 1.91353C24.3429 2.19723 24.4993 2.57407 24.4993 2.97633C24.4993 3.37858 24.3429 3.75543 24.0597 4.03913ZM14.1431 13.9741L11.3138 14.6826L12.0211 11.8485L20.3469 3.50843L22.4689 5.63403L14.1431 13.9741ZM25.1207 0.852144C23.9878 -0.284048 22.011 -0.284048 20.8767 0.852144L10.8122 10.9339C10.7164 11.0299 10.6474 11.1513 10.6149 11.2825L9.55537 15.5323C9.49197 15.7878 9.56665 16.0588 9.75264 16.2465C9.89494 16.389 10.0866 16.4667 10.2824 16.4667C10.343 16.4667 10.4036 16.4596 10.4642 16.4441L14.7081 15.3813C14.8406 15.3488 14.9603 15.2797 15.0561 15.1837L25.1207 5.10192C25.6871 4.53453 25.9999 3.77943 25.9999 2.97633C25.9999 2.17323 25.6885 1.41953 25.1207 0.852144Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c8e1cf2b552033ca03f2aa017027622a.svg";
export { ForwardRef as ReactComponent };